import { ref } from 'vue';

/** P1-ALT-001 — five primary Alert Hub tabs. QA_FE_LAYOUT_CLEAN_V1 shorter labels. */
export const ALERT_HUB_TABS = [
  { id: 'connections', label: 'Connections' },
  { id: 'destinations', label: 'Destinations' },
  { id: 'routing', label: 'Routing' },
  { id: 'escalations', label: 'Settings' },
  { id: 'delivery', label: 'Delivery' },
];

export function useQaAlertHubTabs(initialTab = 'connections') {
  const activeTab = ref(initialTab);
  const isTab = tabId => activeTab.value === tabId;
  const setTab = tabId => {
    if (ALERT_HUB_TABS.some(tab => tab.id === tabId)) {
      activeTab.value = tabId;
    }
  };

  return {
    activeTab,
    tabs: ALERT_HUB_TABS,
    isTab,
    setTab,
  };
}
